module.exports = __webpack_public_path__ + "static/media/ico_edit.347900d9.svg";